<div class="container mx-auto">
    Redirecting...
</div>
